import { useContext } from "react";
import ProfileAggregator from "../../../applicationUI/aggregator/ProfileAggregator";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import Context from "../../../../Context";
import adminAccess from "../../../../data/adminAccess";
import MessageBox from "../../../helperComponents/MessageBox";
import ProfileCardForDocumentVerification from "../profiles/ProfileCardForDocumentVerification";

export default function DocumentVerification() {
  const { loggedInUser } = useContext(Context);

  if (!adminAccess.includes(loggedInUser.username))
    return <MessageBox>Permission Denied</MessageBox>;

  return (
    <LoggedInBoilerplate
      showBackButton={true}
      titleLine1={"Document Verification"}
      titleLine2={"Dashboard"}
    >
      <br /> <br />
      <ProfileAggregator
        ItemCard={ProfileCardForDocumentVerification}
        columns={2}
        showNgoWithPendingVerification={true}
      />
    </LoggedInBoilerplate>
  );
}
